import { render, staticRenderFns } from "./Remind_pay.vue?vue&type=template&id=55ad1610&scoped=true"
import script from "./Remind_pay.vue?vue&type=script&lang=js"
export * from "./Remind_pay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ad1610",
  null
  
)

export default component.exports